const Pictures: any = {

  rock1: require("../data/png/rock1.png"),
  rock2: require("../data/png/rock2.png"),
  rock3: require("../data/png/rock3.png"),
  rockme: require("../data/png/rockme.png"),
  emoji: require("../data/png/emoji.gif"),
  rock9: require("../data/png/9.png"),
  logo: require("../data/png/rocknbones.png")

};

export default Pictures;